// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"e49a0903","636":"c4ff613d"}[chunkId] + ".chunk.js";
};